<template>
    <!-- 报名须知  政策文件 实时新闻 通知公告 关于我们 职业标准-->
    <div style="position: relative;top:0px;">
        <div class="inner" style="width: 1300px;margin: 0 auto;">
            <div class="mod clearfix">
                <div class="col_menu">
                    <div class="col_menu_head">
                        <h3 class="col_name" frag="窗口3" portletmode="simpleColumnAnchor">
                            <span class="col_name_text">
                                <span class="Column_Anchor">学校概况</span>
                            </span>
                        </h3>
                        <a class="column-switch"></a>
                    </div>
                    <div class="col_menu_con" frag="面板4">
                        <div class="col_list" frag="窗口4" portletmode="simpleColumnList">

                            <ul class="wp_listcolumn list-paddingleft-2">

                                <li class="wp_column column-1 selected" v-for="(item,index) in list" :key="index"
                                    @click="a(index+1)">
                                    <a title="" :class="item.state ==2? 'col_item_link selected':'col_item_link'"><span
                                            class="column-name">{{item.name}}</span></a>
                                </li>

                            </ul>

                        </div>
                    </div>

                    <div class="post post2 post-13 mbox" frag="窗口42">
                        <div class="con">
                        </div>
                    </div>
                </div>
                <div class="col_news">
                    <div class="col_news_box">
                        <div class="col_news_head">
                            <ul class="col_metas clearfix" frag="窗口5" portletmode="simpleColumnAttri">
                                <li class="col_title">
                                    <h2>{{title}}</h2>
                                </li>
                            </ul>
                        </div>
                        <div class="col_news_imgs">
                            <img class="col_imgs" style="width: 1000px;height: 200px;"
                                src="https://www.sgap.edu.cn/images/ny/nybanner.jpg">
                        </div>
                        <div class="col_news_con">
                            <div class="col_news_list listcon">
                                <div frag="窗口6" portletmode="simpleList">

                                    <div class="wp_single wp_column_article" id="wp_column_article">
                                        <div class="wp_entry">
                                            <div class="wp_articlecontent">
                                                <div data-v-9c94c636="" id="richtext">
                                                    <!-- 学校简介 -->
                                                    <div v-if="flagShowOrHide1">
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">山西通用航空职业技术学院是公办全日制高等职业技术学院。学院经教育部备案，由山西省人民政府批准设立，大同市人民政府举办并管理，接受山西省教育厅业务指导和监督检查。学院办学定位为高等职业院校，主要培养培训专科层次技能型通用航空人才。</span>
                                                        </p>
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">学院是教育部"一站式"学生社区综合管理模式建设自主试点单位、全国无人机行业产教融合共同体理事单位、中国航空器拥有者及驾驶员协会常务理事单位、全国征兵工作先进单位、山西省级通用航空产教融合空训基地、省级通用航空市域产教联合体牵头单位、山西省通航产业联盟专家委员会成员单位、山西省无人机高水平实训基地、山西省科普教育基地、山西省首批大中小学生劳动教育实践基地、山西省兵员预征预储试点单位、创建省文明校园先进单位、大同市五一劳动奖状获奖单位。</span>
                                                        </p>
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">学院座落于中国古都大同，总占地面积556亩，总规划建筑面积28.08万平方米，23万平方米已投入使用。学院现有各类教学科研仪器设备总值近5000万元，纸质图书17.9万册，数字资源4305151册。</span>
                                                        </p>
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">学院坚持高起点、高标准办学，聘请了一批行业知名专家学者指导办学，先后从北京航空航天大学、南京航空航天大学等国内一流重点高校选聘院长担纲办学。现任院长阎雷，长期从事民航通航教育和产业管理工作，曾任南京航空航天大学飞行学院院长、产业党工委书记、资产经营有限公司总经理。学院现有教职员工228人，专任教师174人、副教授（副研究员）以上职称10人，具有博士研究生学位的教师6人。此外，还从知名高等院校、企业等聘请高水平师资数十人。学院规划办学规模6000人，现有在籍学生4610人。</span>
                                                        </p>
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">学院坚持行业特色办学和服务区域经济发展有机结合，重点面向民航通航产业、先进制造业、现代服务业、低空经济产业和数字经济产业，强化"特色+优势"、"通航+通用"、"技能+服务"专业发展内涵，进一步优化学科专业。目前已成立航空工程系、航空运输系、无人机系、信息技术系等4个二级学系。重点布局4个专业集群，18个专业。航空工程与先进制造专业群包括通用航空器维修、飞机机电设备维修、航空地面设备维修、智能机电技术、增材制造技术、新能源汽车技术6个专业；航空运输与现代服务专业群包括民航运输服务、空中乘务、通用航空航务技术、民航安全技术管理、机场运行服务与管理、航空物流管理6个专业；无人机制造与应用专业群包括无人机应用技术、无人机测绘技术、智能机器人技术3个专业。信息技术与人工智能专业群包括工业软件开发技术、云计算应用技术、人工智能技术应用3个专业。</span>
                                                        </p>
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">学院通过产教融合、校企合作等方式，与首都国际机场、杭州萧山国际机场、广州白云国际机场、成都纵横自动化技术股份有限公司、厦门航空有限公司、太原航空集团有限公司、华舰体育控股有限公司、山西通航产业集团有限公司、南六庄机场、京东云大同电商生态产业园、山西通用航空集团、山西通航协会等40余家企业、社会组织合作，构建校企多元育人模式，多方位保障人才培养质量。</span>
                                                        </p>
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">学院始终坚持以习近平新时代中国特色社会主义思想为指导，聚焦全方位推动高质量发展的重大战略任务，以立德树人为根本，以党的建设为统领，学科专业为龙头、师资队伍为关键、人才培养为中心、校企合作为抓手、规范治理为保障，强化特色立院、人才强院、开放办院、质量兴院，推进专业做实、需求做大、质量做优、供给做强，建设文明、绿色、平安、智慧、清廉"五个山航"，为早日建成专业优势突出、特色鲜明、地方一流、国内知名的高水平职业高等学校而努力奋斗！</span>
                                                        </p>
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);"><br></span>
                                                        </p>

                                                    </div>

                                                    <!-- //学校项目 -->
                                                    <div v-if="flagShowOrHide2">
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">（一）成人高等教育<br></span>
                                                        </p>
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">&nbsp;
                                                                &nbsp;
                                                                继续教育学院依托优质的师资和科研实力，整合国内优质教育资源，面向社会开展高质量、高水平、高层次的学历教育。学院具有函授、业余等办学形式，具有高中起点专科、专科起点本科、高中起点本科三个办学层次，二十多个本、专科专业均为国家及地方经济建设与社会发展所需的主导学科专业，在历年由山西省教育厅组织的对主办院校所设函授站评估中，通过率名列全省本科院校第一名。所获学历可用于职称评定、职业资格证书的认定等。</span>
                                                        </p>
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">学历及学位证书，学生学习期满，经考试成绩全部合格，颁发相应层次的经国家教育部验印的毕业证书，对于符合学位授予条件的本科毕业生，授予相应学科学士学位，所获学历及学位证信息学信网终身可查，为国家承认学历。</span>
                                                        </p>
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">（二）国家级专业技术人员继续教育基地·继续教育及相关管理工作</span>
                                                        </p>
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">&nbsp;
                                                                &nbsp;提供继续教育服务的主要形式包括：承办国家级专业技术人员继续教育重大专项工程项目；举办政府部门、行业协会、企事业单位委托的培训班、研修班或进修班；协助开展专业技术人员公需科目或专业科目的培训、考核和管理工作；开展继续教育理论研究，开发有针对性和实效性的培训项目与培训课程；举办继续教育交流服务活动；承担政府部门委托的继续教育公共服务项目，实施公益性继续教育时要向各个地区、各类经济组织和广大专业技术人员平等开放，并对革命老区、民族地区、边远地区和贫困地区给予倾斜。</span>
                                                        </p>
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">（三）职业资格等级认定</span>
                                                        </p>
                                                        <p
                                                            style="margin-bottom: 18px; text-align: left; background: rgb(255, 255, 255);   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">&nbsp;&nbsp;根据相关规定，劳动者参加职业技能评价后可以获取职业资格证书，职业技能等级证书、专项职业能力证书等；职业资格证书是经政府备案的职业技能考核鉴定机构按照国家职业技能标准，对劳动者的技能水平进行客观公正、科学、规范的评价和鉴定，由政府统一核发的对劳动者具有从事某一职业所必须具备的学识和技能的证明。按照国家职业技能标准和行业企业评价规范，对劳动者进行职业技能等级评价，由认定机构颁发的对劳动者从事的职业或岗位能达到的技能能力等级证明。人力资源社会保障部门选择就业需求量大、操作技能简单易学的就业技能，开展专项职业能力考核，对合格人员发放专项职业能力证书。专项职业能力证书是劳动者熟练掌握并应用某项实用职业技能的证明，表明证书持有人具备了从事某职业岗位所必需的基础工作能力。取得职业资格证书、职业技能等级证书、专项职业能力证书，表明劳动者具备了相应职业技能。只有考取职业资格证书或职业技能等级证书的，才纳入人才统计范围，落实相关政策，并兑换相关待遇。根据《国家职业技能标准编制技术规程（2018年版）》，职业技能一般分为五个等级，由低到高可分为：五级/初级工、四级/中级工、三级/高级工、二级/技师、一级/高级技师。国家职业技能标准根据各职业的实际情况，确定该职业的技能等级级次。职业资格证书和职业技能等级证书一般设高级技师、技师、高级工、中级工、初级工5个等级；专项职业能力证书不设等级。</span>
                                                        </p>
                                                        <p
                                                            style="white-space: normal; text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">（四）山西转型综合改革示范区职业技术实训服务</span>
                                                        </p>
                                                        <p
                                                            style="margin-bottom: 18px; white-space: normal; text-align: left; background: rgb(255, 255, 255);   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">&nbsp;&nbsp;主要职能是负责为高端装备制造、新能源、信息技术、新能源汽车等主导产业培养急需的各类高技能人才；负责为重点企业用工需求提供订单式培训服务；负责示范区相关产业和企业的实训基地建设，逐步形成主导产业和重点企业从研发设计到生产制造、提升产业价值链。</span>
                                                        </p>
                                                    </div>

                                                    <!-- 学校地址 -->
                                                    <div v-if="flagShowOrHide3">
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">地址：大同市云州区通航产业园航苑路1号</span>
                                                        </p>
                                                        <!-- <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">&nbsp;
                                                                （1）继续教育学院职业技能等级认定中心（太原市万柏林区西矿街53号继续教育学员一层106室）</span>
                                                        </p>
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">&nbsp;
                                                                联系人：王老师 13303513697 &nbsp;电话：0351-6018869</span>
                                                        </p>
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">&nbsp;
                                                                （2）科技产业孵化园（太原市和平北路28号）</span>
                                                        </p>
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">&nbsp;
                                                                联系人：乔老师 18635110506 &nbsp;电话：0351-3620999</span>
                                                        </p>
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">&nbsp;
                                                                （3）山西转型综合改革示范区职业技术实训服务中心</span>
                                                        </p>
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">&nbsp;
                                                                继续教育学院继续教育实训基地（山西转型综合改革示范区人才引进交流服务中心太原市龙盛街52号盛玖大厦B座313室）</span>
                                                        </p>
                                                        <p style="text-align: left;   line-height: 2em;">
                                                            <span
                                                                style="line-height: 150%; font-family: 微软雅黑,  Microsoft YaHei ; font-size: 16px; color: rgb(0, 0, 0);">&nbsp;
                                                                联系人：郝老师 17310535369
                                                                &nbsp;&nbsp;电话：18534396019&nbsp;</span>
                                                        </p> -->
                                                        <p><br></p>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>

        <el-backtop>
        </el-backtop>
    </div>
</template>

<script>
    //import homePage from './components/homePage.vue';
    export default {
        name: 'app',
        components: {
            //homePage
        },
        data() {
            return {
                title: '学校简介',
                list: [{
                    name: '学校简介',
                    state: 2
                }
                // , {
                //     name: '学校项目',
                //     state: 1
                // }
                , {
                    name: '学校地址',
                    state: 1
                }
                ],
                flagShowOrHide1: true,
                flagShowOrHide2: false,
                flagShowOrHide3: false,
                loadingFlag: false,
                total: 0,   //一共多少条
                pagesize: 4,  //一页几条
                currentPage: 1,//当前页
                navId: '',
                navigationName: '',
                tableData: []
            }
        },
        created() {
            this.navId = this.$route.params.navId;
            this.loadData(this.currentPage, this.pagesize);
        },
        methods: {
            a(index) {
                this.list.forEach((ekl, index) => {
                    ekl.state = 1
                })
                this.list[index - 1].state = 2

                if (index == 1) {
                    this.title = '学校简介'
                    this.flagShowOrHide1 = true;
                    this.flagShowOrHide2 = false;
                    this.flagShowOrHide3 = false;
                } 
                // else if (index == 2) {
                //     this.title = '学校项目'
                //     this.flagShowOrHide1 = false;
                //     this.flagShowOrHide2 = true;
                //     this.flagShowOrHide3 = false;
                // } 
                else if (index == 2) {
                    this.title = '学校地址'
                    this.flagShowOrHide1 = false;
                    this.flagShowOrHide2 = false;
                    this.flagShowOrHide3 = true;
                }
            },
            homePage() {
                this.$router.push({ path: '/homePage' })
            },
            detail(item) {
                this.$router.push({ path: '/journalismNoticeDetail/' + item.id + "/" + item.navName })
            },
            imgerrorfun(index) {
                this.tableData[index].src = '../static/img/logo.png';
            },
            //切换每页多少条 触发
            handleSizeChange(val) {
                this.pagesize = val;
                this.loadData(this.currentPage, this.pagesize);
            },
            //第几页切换的时 触发
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loadData(this.currentPage, this.pagesize);
            },
            loadData(page, limit) {
                this.loadingFlag = true;
                let navId = 0;
                if (this.navId === '1') {
                    this.navigationName = '报名须知';
                    navId = 26;
                    this.$parent.navigationSwitchover(1);
                } else if (this.navId === '2') {
                    this.navigationName = '政策文件';
                    navId = 27;
                    this.$parent.navigationSwitchover(3);
                } else if (this.navId === '3') {
                    this.navigationName = '实时新闻';
                    navId = 28;
                    this.$parent.navigationSwitchover(4);
                } else if (this.navId === '4') {
                    this.navigationName = '通知公告';
                    navId = 29;
                    this.$parent.navigationSwitchover(5);
                } else if (this.navId === '5') {
                    this.navigationName = '关于我们';
                    navId = 31;
                    this.$parent.navigationSwitchover(6);
                } else if (this.navId === '6') {
                    this.navigationName = '职业标准';
                    navId = 32;

                    this.$parent.navigationSwitchover(7);
                } else if (this.navId === '7') {
                    this.navigationName = '招生简章';
                    navId = 35;

                    this.$parent.navigationSwitchover(2);
                }
                let parames = new URLSearchParams();
                parames.append('navId', navId);
                parames.append('page', page);
                parames.append('limit', limit);
                parames.append('organStatus', this.organStatus);

                this.$axios.post(this.serverUrl + '/navList', parames).then(resp => {

                    this.total = resp.data.count;

                    if (resp.data.code === 1) {

                        let ArrayList = [];
                        resp.data.data.forEach(element => {

                            let slideshowVo = {
                                id: 0,
                                navName: '',
                                src: '',
                                contentTitle: '',
                                insertTime: ''
                            }
                            slideshowVo.src = this.serverUrl + this.prefiexUrl + element.contentPic;

                            slideshowVo.id = element.id;
                            slideshowVo.navName = element.navName;

                            slideshowVo.contentTitle = element.contentTitle;

                            if (element.insertTime != null) {
                                slideshowVo.insertTime = element.insertTime.substring(0, 10);
                            } else {
                                slideshowVo.insertTime = '暂无';
                            }

                            ArrayList.push(slideshowVo);
                        })

                        this.tableData = ArrayList;
                        this.loadingFlag = false;

                    }
                }).catch(err => {
                    this.$message({
                        message: '服务器繁忙！',
                        type: 'warning'
                    });
                })
            }
        }
    }
</script>


<style scoped>
    .clearfix:after {
        clear: both;
        content: ".";
        display: block;
        height: 0;
        visibility: hidden;
    }

    .clear {
        width: 100%;
        height: 0;
        line-height: 0;
        font-size: 0;
        overflow: hidden;
        clear: both;
        display: block;
        display: inline;
    }

    .col_news_list .wp_entry *,
    .col_news_list .wp_entry p,
    .col_news_list .wp_entry p * {
        font-family: 'Noto Serif CJK SC', 'Noto Serif CJK', 'Source Han Serif SC', ‘Source Han Serif’, source-han-serif-sc, serif !important;
    }

    .col_news_list .wp_entry p {
        margin-bottom: 20px;
    }

    .col_news_list .wp_entry *,
    .col_news_list .wp_entry p,
    .col_news_list .wp_entry p * {
        font-family: 'Noto Serif CJK SC', 'Noto Serif CJK', 'Source Han Serif SC', ‘Source Han Serif’, source-han-serif-sc, serif !important;
    }

    .col_news_list .wp_entry *,
    .col_news_list .wp_entry p,
    .col_news_list .wp_entry p * {
        font-family: 'Noto Serif CJK SC', 'Noto Serif CJK', 'Source Han Serif SC', ‘Source Han Serif’, source-han-serif-sc, serif !important;
    }

    .col_news_list .wp_entry,
    .col_news_list .wp_entry p .col_news_list .wp_entry p span {
        line-height: 2;
        font-size: 15px !important;
        color: #333;
    }

    .col_news_list {
        margin-top: 7px;
    }

    .col_news_con {
        padding: 30px 0px 30px 0px;
        margin: 0 0px;
    }

    .col_news_imgs .col_imgs {
        width: 100%;
    }

    .col_news_imgs {
        margin-top: 15px;
    }

    .clearfix:after {
        clear: both;
        content: ".";
        display: block;
        height: 0;
        visibility: hidden;
    }

    .col_metas .col_title h2 {
        display: inline-block;
        font-size: 24px;
        font-family: 'Noto Serif CJK SC', 'Noto Serif CJK', 'Source Han Serif SC', ‘Source Han Serif’, source-han-serif-sc, serif;
        font-weight: normal;
        color: #0f429b;
        border-bottom: 2px solid #204f9f;
    }

    .col_metas .col_title {
        display: inline-block;
        height: 48px;
        line-height: 48px;
    }

    .col_metas .col_path {
        display: inline-block;
        white-space: nowrap;
        height: 46px;
        line-height: 46px;
        color: #666;
    }

    .clearfix {
        display: block;
    }

    .col_news_head {
        border-bottom: 1px solid #DBDBDB;
    }

    .col_news .col_news_box {
        margin-left: 290px;
    }

    .col_news {
        width: 100%;
        min-height: 500px;
        float: right;
    }

    .col_list .wp_listcolumn .wp_column a:hover,
    .col_list .wp_listcolumn .wp_column a.selected {
        color: #0f429b;
        background: #fff;
    }

    a {
        color: #000;
        text-decoration: none;
        transition: all 0.4s ease-in-out;
    }

    .wp_listcolumn .wp_column a {
        display: block;
        width: 100%;
        color: #666;
        font-size: 15px;
        font-weight: bold;
        word-wrap: break-word;
        /* background: #f5f5f5 url(wp_column_menu_li_1.gif) no-repeat 6px 12px; */
        border-bottom: 1px solid #ddd;
        border-top: 1px solid #fff;
        text-align: left;
    }

    .col_list .wp_listcolumn .wp_column a {
        color: #333;
        font-size: 15px;
        font-weight: normal;
        background: none;
        border-top: 0px solid #fff;
        border-bottom: 1px solid #F6EAEA;
    }

    .wp_listcolumn .wp_column a .column-name {
        display: inline-block;
        line-height: 22px;
        padding: 5px 10px 5px 20px;
        cursor: pointer;
    }

    .col_list .wp_listcolumn .wp_column a .column-name {
        padding: 5px 0px 5px 45px;
        line-height: 35px;
    }

    .col_list .wp_listcolumn .wp_column a.selected span.column-name {
        color: #0f429b;
        background: url(images/../../../static/img/sub_nav_li.jpg) no-repeat 25px center;
    }

    .col_list .wp_listcolumn .wp_column a {
        color: #333;
        font-size: 15px;
        font-weight: normal;
        background: none;
        border-top: 0px solid #fff;
        border-bottom: 1px solid #F6EAEA;
    }

    .col_list .wp_listcolumn .wp_column a.selected {
        font-weight: bold;
        color: #0f429b;
        background: #fff;
    }

    .wp_listcolumn .wp_column {
        display: block;
        width: 100%;
    }

    .wp_listcolumn {
        display: block;
        width: 100%;
        border-top: 1px solid #ddd;
        border-bottom: 1px solid #fff;
    }

    .col_list .wp_listcolumn {
        border-top: 0px solid #2867A0;
        border-bottom: 0px solid #fff;
        padding-left: 12px;
    }

    .col_list {
        overflow: hidden;
    }

    .col_menu .col_menu_con {
        border: 0px solid #e4e4e4;
        padding-top: 12px;
        padding-bottom: 152px;
        margin-bottom: 35px;
        background: #eeeff1 url(images/../../../static/img/sub_nav_bg.jpg) no-repeat bottom right;
    }

    .column-switch {
        display: none;
        /* position: absolute; */
        /* right: 10px; */
        /* top: 8px; */
        /* width: 30px; */
        /* height: 24px; */
        /* float: right; */
        /* background: url(css/img/menu-dot-w.png) no-repeat center; */
    }

    .col_menu .col_menu_head h3.col_name .col_name_text:after {
        content: '';
        position: absolute;
        left: 24px;
        bottom: 16px;
        margin-left: 0px;
        width: 38px;
        height: 1px;
        background: #fff;
    }

    .col_menu .col_menu_head h3.col_name {
        font-size: 28px;
        font-weight: normal;
        color: #fff;
    }

    .col_menu .col_menu_head h3.col_name .col_name_text {
        display: block;
        line-height: 50px;
        padding: 14px 5px 20px 24px;
        position: relative;
    }

    .col_menu .col_menu_head {
        background: #204f9f;
    }

    .col_menu .col_menu_head h3.col_name .col_name_text {
        display: block;
        line-height: 50px;
        padding: 14px 5px 20px 24px;
        position: relative;
    }

    .col_menu .col_menu_head h3.col_name {
        font-size: 28px;
        font-weight: normal;
        color: #fff;
    }

    .col_menu .col_menu_head {
        position: relative;
    }

    .col_menu {
        width: 240px;
        float: left;
        margin-top: 15px;
        margin-right: -240px;
        position: relative;
    }

    .wrapper .inner {
        width: 1250px;
        margin: 0 auto;
    }

    #l-container .inner {
        padding: 48px 10px 25px;
    }
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue